import {
  Button,
  COLOR,
  FocusPage,
  getColor,
  StripeHeader,
  StripeTitle,
  useMatchMediaTierProp,
} from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import { Outlet } from "react-router"
import { useOfferData } from "../app/hooks"
import { useOfferScreenFlow } from "../hooks/useOfferScreenFlow"
import "../modules/Offer/offer.css"
import { OfferModalProvider } from "../modules/Offer/OfferModalContext"
import { useOfferSettings } from "../modules/Offer/OfferSettingsContext"
import OfferStepper from "../modules/Offer/OfferStepper"

const OfferLayout = () => {
  const { t } = useTranslation()
  const offerData = useOfferData()
  const { setNextStep } = useOfferScreenFlow()
  const { isCloseButtonVisible } = useOfferSettings()

  const stepperContent = <OfferStepper />

  const centerHeader = <StripeTitle>{t("offers.pageTitle")}</StripeTitle>

  const closeButton = isCloseButtonVisible ? (
    <Button
      icon={Button.ICON.ERROR}
      variant={Button.VARIANT.TERTIARY}
      onClick={() => setNextStep(offerData?.caseId, true)}
    >
      {t("offers.button.close")}
    </Button>
  ) : null

  const stripeHeaderContent = useMatchMediaTierProp({
    xs: (
      <StripeHeader
        center={centerHeader}
        variant={StripeHeader.VARIANT.TRANSPARENT}
        right={closeButton}
        sticky
      />
    ),
    md: <StripeHeader center={centerHeader} right={closeButton} sticky />,
  })

  return (
    <OfferModalProvider>
      <FocusPage stepper={stepperContent} stripeHeader={stripeHeaderContent}>
        <Outlet />
      </FocusPage>
    </OfferModalProvider>
  )
}

const OfferInfoLayout = () => {
  const { t } = useTranslation()
  const offerData = useOfferData()
  const { setNextStep } = useOfferScreenFlow()
  const { isCloseButtonVisible } = useOfferSettings()

  const pageContent = useMatchMediaTierProp({
    xs: (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: getColor(COLOR.BLUE_BRIGHT)?.value,
        }}
      >
        <OfferModalProvider>
          <FocusPage
            stripeHeader={
              <StripeHeader
                center={<StripeTitle>{t("offers.pageTitle")}</StripeTitle>}
                right={
                  isCloseButtonVisible ? (
                    <Button
                      icon={Button.ICON.ERROR}
                      variant={Button.VARIANT.TERTIARY}
                      onClick={() => setNextStep(offerData?.caseId, true)}
                    >
                      {t("offers.button.close")}
                    </Button>
                  ) : null
                }
                sticky
              />
            }
          >
            <Outlet />
          </FocusPage>
        </OfferModalProvider>
      </div>
    ),
    md: <OfferLayout />,
  })

  return <>{pageContent}</>
}

export { OfferInfoLayout, OfferLayout }
